import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=232c6c2b&scoped=true&"
import script from "./SingleVideo.vue?vue&type=script&lang=js&"
export * from "./SingleVideo.vue?vue&type=script&lang=js&"
import style0 from "./SingleVideo.vue?vue&type=style&index=0&id=232c6c2b&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c6c2b",
  null
  
)

export default component.exports